import React from 'react';
import './Footer.css'; // Import your CSS file

const socialIcons = [
    { name: 'Instagram', icon: 'https://img.icons8.com/fluency/48/000000/instagram-new.png', link: 'https://www.instagram.com/ambitionjet/?utm_source=qr&igsh=bmVsbjhtdTkzYTVj#' },
    { name: 'Twitter', icon: 'https://img.icons8.com/fluency/48/000000/twitter.png', link: 'https://x.com/AmbitionJet?t=sAvX0-XRd2zkZ0_wz6OlRg&s=08 ' },
    { name: 'LinkedIn', icon: 'https://img.icons8.com/fluency/48/000000/linkedin.png', link: 'https://www.linkedin.com/in/ambition-jet-plarform-369478353/' },
    { name: 'Facebook', icon: 'https://img.icons8.com/fluency/48/000000/facebook.png', link: 'https://www.facebook.com/ambitionjet' },
];

const menuItems = ['About Us', 'Contact', 'Career', 'Donate'];
const menu2Items = ['References', 'Achievements', 'See our impact', 'Terms of use'];

const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="footer-container">
                <div className="social-icons">
                    <h4>Follow us for more updates</h4>
                    {socialIcons.map((social) => (
                        <a key={social.name} href={social.link} target="_blank" rel="noopener noreferrer">
                            <img src={social.icon} alt={`${social.name} Icon`} />
                        </a>
                    ))}
                </div>
                <div className="menu-column">
                    <div className="menu-section">
                        <ul className="menu-list">
                            {menuItems.map((item) => (
                                <li className="menu-item" key={item}>{item}</li>
                            ))}
                        </ul>
                        <ul className="menu-list">
                            {menu2Items.map((item) => (
                                <li className="menu-item" key={item}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>              
            </div>
        </footer>
    );
};

export default Footer;
